/** Utilidades de avatar: color e iniciales deterministas por identidad. */

/** Hash estable (djb2) de un string a entero sin signo. */
function hash(input: string): number {
  let h = 5381;
  for (let i = 0; i < input.length; i++) {
    h = ((h << 5) + h + input.charCodeAt(i)) >>> 0;
  }
  return h;
}

/**
 * Color HSL estable derivado de una identidad (jid, nombre…). Saturación/luz
 * fijas para legibilidad sobre fondos claros y oscuros.
 */
export function hashColor(seed?: string | null): string {
  const hue = hash(seed ?? '?') % 360;
  return `hsl(${hue}, 65%, 45%)`;
}

/** Hasta 2 iniciales del nombre, o '?'. Para grupos devuelve la del subject. */
export function initials(name?: string | null): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() ?? '').join('') || '?';
}
